import React from 'react';
import _ from 'lodash';

import './styles.css';

const STICKY_BOOKING_COLUMNS = [
  {label: 'Booking', className: 'StickyTableHeaders__booking'},
  {label: 'Members', className: 'StickyTableHeaders__members'},
  {label: 'Status', className: 'StickyTableHeaders__status'},
  {label: 'Type', className: 'StickyTableHeaders__type'},
  {label: 'Start', className: 'StickyTableHeaders__start'},
  {label: 'End', className: 'StickyTableHeaders__end'}
];

const StickyTableHeaders = () => (
  <div className="StickyTableHeaders colab-centered-v">
    {_.map(STICKY_BOOKING_COLUMNS, column => (
      <div key={column.label} className={column.className}>
        {column.label}
      </div>
    ))}
  </div>
);

export default StickyTableHeaders;
